import React from 'react';
import Link from 'react-scroll/modules/components/Link';
import { animateScroll as scroll } from 'react-scroll';

const Header = ({setBlogs}) => {
    const showBlogs=()=>{
        setBlogs(true)
    }
    const manubar = <>
        <li >
            <Link activeClass="active" className='box' to='banner' spy={true} smooth={true} duration={500} offset={-100}>HOME</Link>
        </li>
        <li >
            <Link activeClass="active" className='box' to='about' spy={true} smooth={true} duration={500} offset={-100}>ABOUT</Link>
        </li>
        <li >
            <Link activeClass="active" className='box' to='skills' spy={true} smooth={true} duration={500} offset={-100}>SKILLS</Link>
        </li>
        <li >
            <Link activeClass="active" className='box' to='protfolio' spy={true} smooth={true} duration={500} offset={-100}>PROTFOLIO</Link>
        </li>
        <li >
            <Link onClick={showBlogs} activeClass="active" className='box' to='blogs' spy={true} smooth={true} duration={500} offset={-100}>BLOGS</Link>
        </li>
        <li >
            <Link activeClass="active" className='box' to='contact' spy={true} smooth={true} duration={500} offset={-100}>CONTACT</Link>
        </li>
       


    </>
    
    return (
        <div class="navbar bg-base-100 py-3 sticky top-0 z-10 lg:px-20">
            <div class="navbar-start">
                <div class="dropdown">
                    <label tabindex="0" class="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {manubar}
                    </ul>
                </div>
                <Link onClick={() => scroll.scrollToTop()} to='/' class="normal-case text-xl" ><h1 className='text-neutral text-3xl font-bold cursor-pointer'>Najmul</h1></Link>
            </div>
            <div class="hidden lg:flex">
                <ul class="menu menu-horizontal p-0">
                    {manubar}
                </ul>
            </div>

        </div>
    );
};

export default Header;